export const SET_SEARCH_HISTORY_LIST = 'SET_SEARCH_HISTORY_LIST';
